/* tslint:disable */
/* eslint-disable */
/* @relayHash f74924c8938b4fd13a9c48a17f4370e2 */

import { ConcreteRequest } from "relay-runtime";
export type CreateCommentDontAgreeInput = {
    commentID: string;
    commentRevisionID: string;
    additionalDetails?: string | null;
    clientMutationId: string;
};
export type CreateCommentDisagreeMutationVariables = {
    input: CreateCommentDontAgreeInput;
};
export type CreateCommentDisagreeMutationResponse = {
    readonly createCommentDontAgree: {
        readonly comment: {
            readonly id: string;
            readonly viewerActionPresence: {
                readonly dontAgree: boolean;
            } | null;
        } | null;
        readonly clientMutationId: string;
    } | null;
};
export type CreateCommentDisagreeMutation = {
    readonly response: CreateCommentDisagreeMutationResponse;
    readonly variables: CreateCommentDisagreeMutationVariables;
};



/*
mutation CreateCommentDisagreeMutation(
  $input: CreateCommentDontAgreeInput!
) {
  createCommentDontAgree(input: $input) {
    comment {
      id
      viewerActionPresence {
        dontAgree
      }
    }
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any)
    ], v1 = [
        ({
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "CreateCommentDontAgreePayload",
            "kind": "LinkedField",
            "name": "createCommentDontAgree",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "comment",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ActionPresence",
                            "kind": "LinkedField",
                            "name": "viewerActionPresence",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "dontAgree",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "CreateCommentDisagreeMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "CreateCommentDisagreeMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "id": "f74924c8938b4fd13a9c48a17f4370e2",
            "metadata": {},
            "name": "CreateCommentDisagreeMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = '24cf56a496a4d37ac1130fa81195717c';
export default node;
